import type { ServiceConfigFactory } from '../../types'

export default (({ modelsApi, bootstrapData }) => {
	const {
		platformAPIData: { routersConfigMap },
		platformEnvData: {
			multilingual: multilingualInfo,
			router: { routingInfo },
			location: { metaSiteId, userFileDomainUrl, isPremiumDomain },
		},
		experiments,
	} = bootstrapData

	return {
		metaSiteId,
		routingInfo,
		isPremiumDomain,
		multilingualInfo,
		userFileDomainUrl,
		routersConfig: routersConfigMap,
		getRoleForCompId: modelsApi.getRoleForCompId,
		popupPages: bootstrapData.platformEnvData.popups?.popupPages,
		getCompIdByWixCodeNickname: modelsApi.getCompIdByWixCodeNickname,
		pageUrlRegexIgnoreSpace: experiments['specs.thunderbolt.pageUrlRegexIgnoreSpace'],
	}
}) as ServiceConfigFactory
